// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page_list":"page_list-32a0S1-O clearfix","current":"current-2sm0urfs"};